import React from 'react'
import eventStyle from "../components/css/events.module.scss";
import buttonsStyle from "../components/css/buttonsStyle.module.scss"

import {Link} from 'gatsby'

export default function({data}){
    return (
        <div>
        {
            data.map(event=>{
                return <article className={eventStyle.eventBox}>
                    <div className={eventStyle.eventContent}>
                        <header>
                            <h2>{event.title}</h2>
                            <span className="when">{event.when}</span>
                            <span className="time">{event.time}</span>
                            <span className="where">{event.where}</span>
                        </header>
                    </div>
                    <Link to={event.learnMoreURL} className={buttonsStyle.btn + " "+buttonsStyle.primary}>Register For Webinar</Link>
                    <div className={eventStyle.eventIcon}><img src="/assets/screenicon@2x.png" alt="webinar icon"/></div>
                </article>
            })
        }
        </div>
    )
}